import { render } from "./Candidate-reference.page.vue?vue&type=template&id=596a2166"
import script from "./Candidate-reference.page.vue?vue&type=script&lang=js"
export * from "./Candidate-reference.page.vue?vue&type=script&lang=js"

import "./Candidate-reference.page.vue?vue&type=style&index=0&id=596a2166&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QRating});
